angular.module('callX')
    .directive('customDatePickerSection', ['DateService', function(DateService) {
        return {
            restrict: 'EA',
            templateUrl: 'tpl/blocks/custom_date_picker_section.html',
            replace: true,
            scope: {
                dateChanged: '&',
                ngModel: '=' // Two-way binding
            },
            controller: ['$scope', function($scope) {
                // Initialize date range
                $scope.dateRangeValue = $scope.ngModel ? $scope.ngModel.dateRangeValue : null;

                // Function to update the model and trigger callback
                function updateDateRange(range) {
                    $scope.dateRangeValue = range.split(' - ');
                    $scope.ngModel = { dateRangeValue: $scope.dateRangeValue };
                    // Schedule a safe digest; works even if a digest is already in progress
                    $scope.$evalAsync();
                    $scope.dateChanged({ dateRangeValue: $scope.dateRangeValue });
                }

                // Apply event for date range picker
                $('#custom-date-picker').on('apply.daterangepicker', function(ev, picker) {
                    var range = $('#custom-date-picker').val();
                    updateDateRange(range);
                });

                // Initialize the date picker value
                function setDatePickerValue() {
                    if ($scope.dateRangeValue) {
                        $('#custom-date-picker').val(
                            $scope.dateRangeValue[0] + ' - ' + $scope.dateRangeValue[1]
                        );
                    } else {
                        $('#custom-date-picker').val('');
                    }
                }
                setDatePickerValue();

                // Watch for external changes in ngModel
                $scope.$watch('ngModel', function(newValue) {
                    if (newValue && newValue.dateRangeValue) {
                        $scope.dateRangeValue = newValue.dateRangeValue;
                        setDatePickerValue();
                    }
                });

            }]
        };
    }]);
